<template>
  <section class="rounded-b-lg  mt-4 ">

    <form @submit.prevent="addComment({experiment: currentExperimentId})" novalidate>
      <textarea
        id="comment"
        class="w-full shadow-inner p-4 border-0 mb-2 rounded-lg focus:shadow-outline text-base"
        :disabled="cannotComment"
        :placeholder="$t('messages.type_your_message_here')"
        cols="2"
        rows="2"
        v-model="comment"
        spellcheck="false"></textarea>

      <button
        type="submit"
        class="font-bold py-2 px-4 w-full bg-blue-500 border-blue-500 text-white shadow-md rounded"
        :class="[cannotComment || !comment ? 'opacity-50 cursor-not-allowed' : 'hover:bg-blue-700']"
        :disabled="cannotComment || !comment"
        v-text="$t('messages.send')"
      >
      </button>
    </form>

    <PulseLoader
      v-if="commentsAreVisible"
      :loading="loading"
      color="#000"
      size="10px"
      class="text-center my-4"
    />

    <div v-if="commentsAreHidden" class="pt-4 text-center">
      <p v-text="$t('messages.comments_will_be_visible_after_response')"></p>
    </div>

    <div v-else-if="!loading && !hasComments" class="pt-4 text-center">
      <p v-text="$t('messages.be_the_first_to_comment')"></p>
    </div>

    <div v-else-if="hasComments" class="pt-4">
      <!-- comment-->
      <div
        v-for="comment in currentComments"
        class="bg-white rounded-lg p-3 flex flex-col justify-center items-center md:items-start shadow-lg mb-4"
        :key="comment.id"
      >
        <div class="flex flex-row justify-center mr-2">
          <img
            :alt="comment.username"
            width="48"
            height="48"
            class="rounded-full w-10 h-10 mr-4 shadow-lg mb-4"
            :src="comment.avatar"
          >
          <h3
            class="text-blue-500 font-semibold text-lg text-center md:text-left"
            v-text="comment.username"
          >
          </h3>
        </div>

        <p
          style="width: 90%"
          class="text-gray-600 text-lg text-center md:text-left"
          v-text="comment.body"
        >
        </p>
      </div>
      <!--  comment end-->
    </div>
  </section>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

export default {
  components: {
    PulseLoader
  },

  computed: {
    ...mapGetters('civium', [
      'currentExperimentId'
    ]),

    ...mapGetters('comments', [
      'artifactDataset',
      'commentsAreVisible',
      'commentsAreHidden',
      'fetchingComments',
      'savingComment',
      'currentComments',
      'currentComment',
    ]),

    comment: {
      set(comment) {
        this.$store.dispatch('comments/setCurrentComment', comment);
      },
      get() {
        return this.currentComment;
      }
    },

    /**
     * Can the User comment.
     */
    canComment() {
      return !this.loading && this.commentsAreVisible;
    },

    /**
     * The User cannot comment.
     */
    cannotComment() {
      return !this.canComment;
    },

    /**
     * Fetching or saving comment.
     */
    loading() {
      return this.fetchingComments || this.savingComment;
    },

    /**
     * Check if has comments.
     *
     * @return {boolean}
     */
    hasComments() {
      return this.currentComments.length > 0;
    }
  },

  methods: {
    ...mapActions('comments', [
      'addComment',
    ])
  },
}
</script>
